import React from 'react';
import { useRoomContext } from '@livekit/components-react'; // make sure this points to correct public context hook
import { useStartAudio, useStartVideo } from '@livekit/components-react'; // must be public, otherwise reimplement manually

export function StartMediaButton({ label, ...props }) {
  const room = useRoomContext();

  const { mergedProps: audioProps, canPlayAudio } = useStartAudio({ room, props });
  const { mergedProps, canPlayVideo } = useStartVideo({ room, props: audioProps });

  const { style = {}, ...restProps } = mergedProps;
  const buttonStyle = {
    ...style,
    display: canPlayAudio && canPlayVideo ? 'none' : 'block',
  };

  return (
    <button style={buttonStyle} {...restProps}>
      {label ?? `Start ${!canPlayAudio ? 'Audio' : 'Video'}`}
    </button>
  );
}
